import { Component, Input, OnInit } from '@angular/core';

import { ApprovalService } from 'src/app/pages/approval/services/approval.service';
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';
import { OrderByPipe } from 'src/app/shared/pipe/order-by.pipe';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeInfoService } from 'src/app/core/services/employee-info.service';

@Component({
  selector: 'app-view-report-history-modal',
  templateUrl: './view-report-history-modal.component.html',
  styleUrls: ['./view-report-history-modal.component.css']
})
export class ViewReportHistoryModalComponent implements OnInit {
  @Input() UserKeyID: number;
  @Input() isAdmin: boolean;
  @Input() userData: any;
  formData: { [key: string]: any } = {};
  gridData: any[] = [];
  predicate: any;
  reverse: boolean;
  orderByPipe: OrderByPipe
  gridDataFilter: any[] = [];
  employeeInfo: any;

  constructor(private approvalService: ApprovalService, private employeeService: EmployeeService, private ngbActiveModal: NgbActiveModal, private employeeInfoService: EmployeeInfoService) {
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    this.orderByPipe = new OrderByPipe();
    this.formData.itemsPerPage = 10;
    this.formData.currentPage = 1;
    this.getGrid();
  }

  getGrid() {
    this.approvalService.getWindowHistory(this.UserKeyID).then((response: any) => {
      this.gridData = response;
      this.gridData.forEach(val => {
        val.showAttachment = false;
      });
      this.updateFilteredDocuments();
    });
  }

  viewAttachment(item) {
    var requestParam = "moduleID=" + 7 + "&recordID=" + item.BenefitUserWindowID;
    this.employeeService.getFileAttachmentList(requestParam).then((response: any) => {
      item.attachmentList = response;
      item.showAttachment = !item.showAttachment;
    });
  }

  updateFilteredDocuments() {
    var begin = ((this.formData.currentPage - 1) * this.formData.itemsPerPage);
    var end = begin + this.formData.itemsPerPage;
    this.gridDataFilter = this.gridData.slice(begin, end);
  };

  sortDashboardRows(predicate) {
    if (this.predicate != predicate) {
      this.predicate = predicate;
      this.reverse = false;
    } else {
      this.reverse = !this.reverse;
    }
    this.gridData = this.orderByPipe.transform(this.gridData, this.predicate, this.reverse ? "desc" : "asc");

    this.updateFilteredDocuments();
  }

  generateReport(userWindowID: number) {
    this.approvalService.saveWindowAuditReportData(userWindowID).then((response: any) => {
      this.getGrid();
    });
  }

  closeClicked() {
    this.ngbActiveModal.dismiss();
  }
}
